import React, { useEffect, useRef, useState } from "react"
import TabelaCobrancaAssociado from "../tabela-cobranca";




export default function CobrancaAssociado(props) {

  const { inscricao } = props.match.params;



  return (
    <>
      <TabelaCobrancaAssociado inscricao={inscricao} />
    </>
  )
}